import { z } from 'zod';
import { ROLES, USER_STATUSES } from '../constants/index.js';
import { idSchema } from './common.js';
export const userSchema = z.object({
    id: idSchema,
    entraObjectId: z.string().nullable(),
    email: z.string().email(),
    displayName: z.string(),
    avatarUrl: z.string().nullable(),
    status: z.enum(USER_STATUSES),
    roles: z.array(z.enum(ROLES)).default([]),
    lastLoginAt: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const sessionUserSchema = userSchema.extend({
    isAdmin: z.boolean(),
    timezone: z.string(),
    permissions: z.array(z.string()).default([]),
});
export const createUserSchema = z.object({
    email: z.string().email().max(180),
    displayName: z.string().trim().min(2).max(180),
    entraObjectId: z.string().trim().max(64).nullish(),
    roles: z.array(z.enum(ROLES)).min(1).default(['user']),
    status: z.enum(USER_STATUSES).default('active'),
});
export const updateUserSchema = z.object({
    displayName: z.string().trim().min(2).max(180).optional(),
    status: z.enum(USER_STATUSES).optional(),
    avatarUrl: z.string().url().nullish(),
});
export const setUserRolesSchema = z.object({
    roles: z.array(z.enum(ROLES)).min(1),
});
export const userListQuerySchema = z.object({
    search: z.string().trim().max(120).optional(),
    status: z.enum(USER_STATUSES).optional(),
    role: z.enum(ROLES).optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
    sortBy: z.enum(['displayName', 'email', 'lastLoginAt', 'createdAt']).default('displayName'),
    sortDir: z.enum(['asc', 'desc']).default('asc'),
});
export const teamsExchangeSchema = z.object({
    /** Token obtained from `microsoftTeams.authentication.getAuthToken()`. */
    ssoToken: z.string().min(20),
});
export const auditLogSchema = z.object({
    id: idSchema,
    actorUserId: idSchema.nullable(),
    actor: z
        .object({ id: idSchema, displayName: z.string(), email: z.string() })
        .nullable(),
    action: z.string(),
    entityType: z.string(),
    entityId: z.string().nullable(),
    beforeJson: z.unknown().nullable(),
    afterJson: z.unknown().nullable(),
    ipAddress: z.string().nullable(),
    userAgent: z.string().nullable(),
    correlationId: z.string().nullable(),
    createdAt: z.string(),
});
export const auditLogQuerySchema = z.object({
    actorUserId: idSchema.optional(),
    action: z.string().trim().max(80).optional(),
    entityType: z.string().trim().max(60).optional(),
    entityId: z.string().trim().max(60).optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
});
//# sourceMappingURL=user.js.map